import tools from '@/sag-core/tools'
export default class Operation {
    constructor(name){
        this.name = name
        this.opList = {
            None: 0,
            Loaded: 1,
            Query: 2,
            Delete: 3,
            Insert: 4,
            Update: 5
        }
        this.op = this.opList.None
        
        this.nowOp = ()=>{
            for(let key in this.opList){
                if(this.opList[key] === this.op) return key
            }
            return ''
        }
    
        this.setLoaded = ()=>{
            tools.debug.log({tag: 'gridStatus', title: 'grid狀態顯示追蹤', content: `name: ${this.name}, ${this.nowOp()} to Loaded`})
            this.op = this.opList.Loaded
        }
        
        this.setDelete = ()=>{
            tools.debug.log({tag: 'gridStatus', title: 'grid狀態顯示追蹤', content: `name: ${this.name}, ${this.nowOp()} to Delete`})
            this.op = this.opList.Delete
        }   
    
        this.setQuery = ()=>{
            tools.debug.log({tag: 'gridStatus', title: 'grid狀態顯示追蹤', content: `name: ${this.name}, ${this.nowOp()} to Query`})
            this.op = this.opList.Query
        }
    
        this.setInsert = ()=>{
            tools.debug.log({tag: 'gridStatus', title: 'grid狀態顯示追蹤', content: `name: ${this.name}, ${this.nowOp()} to Insert`})
            this.op = this.opList.Insert
        }
    
        this.setUpdate = ()=>{
            tools.debug.log({tag: 'gridStatus', title: 'grid狀態顯示追蹤', content: `name: ${this.name}, ${this.nowOp()} to Update`})
            this.op = this.opList.Update
        }
    
        this.isLoaded = ()=>{
            return this.op === this.opList.Loaded
        }
    
        this.isDelete = ()=>{
            return this.op === this.opList.Delete
        }
    
        this.isQuery = ()=>{
            return this.op === this.opList.Query
        }
    
        this.isInsert = ()=>{
            return this.op === this.opList.Insert
        }
    
        this.isUpdate = ()=>{
            return this.op === this.opList.Update
        }
    }
}